var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.dataLoaded ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    staticClass: "mt-6",
    attrs: {
      "size": 50,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataLoaded,
      expression: "dataLoaded"
    }],
    staticClass: "mt-1"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex align-end justify-space-between",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("Добавить ")], 1)], 1)], 1), _c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.genders.list
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mr-2 eye-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Просмотр"
          },
          on: {
            "click": function click($event) {
              return _vm.show(item);
            }
          }
        }, [_vm._v(" mdi-eye-outline ")]), _c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Редактировать"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil-outline ")]), _c('v-icon', {
          staticClass: "remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])];
      }
    }])
  })], 1), _c('GenderDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "saveBtnLoading": _vm.btnLoading,
      "selectedItem": _vm.selectedItem,
      "isShowMode": _vm.isShowMode
    },
    on: {
      "saveGender": _vm.saveGender,
      "closeModal": _vm.closeDialog
    }
  }), _c('ConfirmDialog', {
    attrs: {
      "dialog": _vm.confirmDialog,
      "loading": _vm.btnLoading,
      "message": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430?"
    },
    on: {
      "confirm": _vm.removeGender,
      "closeModal": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }